import React from 'react';

const GreenFace = ({ color = '#18745d', size = 142, active, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 142 142"
      {...props}
    >
      <g transform="translate(-3396 21475)">
        <g
          transform="translate(3396 -21475)"
          stroke={color}
          fill={active ? color : 'none'}
          strokeWidth="15"
        >
          <circle cx="71" cy="71" r="71" stroke="none" />
          <circle cx="71" cy="71" r="63.5" fill="none" />
        </g>
        <path
          d="M3431.823-21391.578c2.285,4.762,39.173,39.816,71.69-.559"
          transform="translate(-1 -1)"
          fill="none"
          stroke={active ? 'white' : color}
          strokeWidth="9"
          strokeLinecap="round"
        />
      </g>
    </svg>
  );
};

export default GreenFace;
